/**
 * Fixed role options for the onboarding profile step (maps to users.jobtitle).
 * Matches Figma role menu node 4365:3605.
 */
export const ONBOARDING_ROLES = [
  "Founder / C-level",
  "Engineering leadership",
  "Software engineer / Developer",
  "ML / AI engineer",
  "Data scientist / Researcher",
  "Product",
  "Other",
] as const;

export type OnboardingRole = (typeof ONBOARDING_ROLES)[number];

export const isOnboardingRole = (value: string): value is OnboardingRole =>
  (ONBOARDING_ROLES as readonly string[]).includes(value);
